const SINGLE_DIGIT = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
const DOUBLE_DIGIT = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const BELOW_HUNDRED = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function translate(n) {
    n = Math.trunc(n);
    if (n === 0) return '';
    if (n < 10) return SINGLE_DIGIT[n];
    if (n < 20) return DOUBLE_DIGIT[n - 10];
    if (n < 100) {
        return BELOW_HUNDRED[Math.floor(n / 10) - 2] + (n % 10 ? ' ' + translate(n % 10) : '');
    }
    if (n < 1000) {
        return SINGLE_DIGIT[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + translate(n % 100) : '');
    }
    if (n < 100000) {
        return translate(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + translate(n % 1000) : '');
    }
    if (n < 10000000) {
        return translate(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + translate(n % 100000) : '');
    }
    return translate(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + translate(n % 10000000) : '');
}

export function numberToWord(n) {
    if (typeof n !== 'number' || n < 0) return false;
    if (n === 0) return 'Zero';

    const whole = Math.floor(n);
    const decimal = Math.round((n - whole) * 100);

    let result = translate(whole).trim();
    if (decimal > 0) {
        result += ` and ${translate(decimal).trim()} Paise`;
    }
    return result;
}